const courses = [
  {
    id: new Date().getTime().toString(),
    course: "Web development",
    submenu: [
      {
        category: "React.JS",
      },
      {
        category: "Node.JS",
      },
      {
        category: "CSS",
      },
      {
        category: "HTML 5",
      },
      {
        category: "Angular",
      },
      {
        category: "TypeScript",
      },
      {
        category: "ASP.NET Core",
      },
    ],
  },
  {
    id: new Date().getTime().toString(),
    course: "Mobile development",
    submenu: [
      {
        category: "Google Flutter",
      },
      {
        category: "React Native",
      },
      {
        category: "iOS Develpmet",
      },
      {
        category: "Dart (Programming Language)",
      },
      {
        category: "Swift",
      },
      {
        category: "Swift UI",
      },
      {
        category: "Kotlin",
      },
    ],
  },
  {
    id: new Date().getTime().toString(),
    course: "Game development",
    submenu: [
      {
        category: "Unity",
      },
      {
        category: "Unreal Engine",
      },
      {
        category: "Game Developmet Fundamentals",
      },
      {
        category: "C#",
      },
      {
        category: "3D Game Development",
      },
      {
        category: "C++",
      },
      {
        category: "Godot",
      },
    ],
  },
  {
    id: new Date().getTime().toString(),
    course: "Entrepreneurship",
    submenu: [
      {
        category: "Business Fundamentals",
      },
      {
        category: "Entrepreneurship Fundamentals",
      },
      {
        category: "Freelance",
      },
      {
        category: "Startup",
      },
      {
        category: "Online Business",
      },
      {
        category: "Business Strategy",
      },
      {
        category: "Business Plan",
      },
      {
        category: "Blogging",
      },
      {
        category: "ChatGPT",
      },
    ],
  },
  {
    id: new Date().getTime().toString(),
    course: "Business Analytics",
    submenu: [
      {
        category: "Microsoft Power BI",
      },
      {
        category: "SQL",
      },
      {
        category: "Data Modelling",
      },
      {
        category: "Business Analysis",
      },
      {
        category: "Data Analysis",
      },
      {
        category: "Data Warehouse",
      },
      {
        category: "DAX",
      },
    ],
  },
  {
    id: new Date().getTime().toString(),
    course: "Digital Marketing",
    submenu: [
      {
        category: "Social Media Marketing",
      },
      {
        category: "Marketing Strategies",
      },
      {
        category: "Google Analytics",
      },
      {
        category: "Copy Writing",
      },
      {
        category: "Startups",
      },
      {
        category: "Internet Marketing",
      },
      {
        category: "Email Marketing",
      },
    ],
  },
  {
    id: new Date().getTime().toString(),
    course: "Graphic Design",
    submenu: [
      {
        category: "Photoshop",
      },
      {
        category: "Adobe Illustrator",
      },
      {
        category: "Canva",
      },
      {
        category: "Drawing",
      },
      {
        category: "Digital Painting",
      },
      {
        category: "InDesign",
      },
    ],
  },

  {
    id: new Date().getTime().toString(),
    course: "IT Certification",
    submenu: [
      {
        category: "AWS",
      },
      {
        category: "COMPTIA++",
      },
      {
        category: "Amazon AWS",
      },
      {
        category: "COMPTIA A+ Security",
      },
      {
        category: "Cisco CCNA",
      },
      {
        category: "Microsoft AZ-900",
      },
      {
        category: "Information Security",
      },
    ],
  },

  {
    id: new Date().getTime().toString(),
    course: "Personnal Transformation",
    submenu: [
      {
        category: "Life Coaching",
      },
      {
        category: "Personal Development",
      },
      {
        category: "Personal Transformation",
      },
      {
        category: "Sound Therapy",
      },
      {
        category: "Life Purpose",
      },
      {
        category: "Mindfulness",
      },
      {
        category: "Emotional Intelligence",
      },
    ],
  },
  {
    id: new Date().getTime().toString(),
    course: "All Categories",
    submenu: [
      {
        category: "Development",
      },
      {
        category: "Music",
      },
      {
        category: "Business",
      },
      {
        category: "Finance & Accounting",
      },
      {
        category: "Personal Development",
      },
      {
        category: "Design",
      },
      {
        category: "Marketing",
      },
      {
        category: "Lifestyle",
      },
      {
        category: "Health & Fitness",
      },
    ],
  },
];

export default courses;
